"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ELROND_LEDGER_VALIDATOR_ADDRESS = exports.ELROND_STAKING_POOL = exports.ELROND_EXPLORER_URL = exports.DECIMALS_LIMIT = exports.MIN_DELEGATION_AMOUNT = exports.CHAIN_ID = exports.GAS_PRICE_MODIFIER = exports.GAS_PER_DATA_BYTE = exports.MIN_GAS_LIMIT = exports.GAS_PRICE = exports.GAS = exports.MAX_PAGINATION_SIZE = exports.METACHAIN_SHARD = exports.HASH_TRANSACTION = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
exports.HASH_TRANSACTION = {
    version: 2,
    options: 1
};
exports.METACHAIN_SHARD = 4294967295;
exports.MAX_PAGINATION_SIZE = 50;
exports.GAS = {
    ESDT_TRANSFER: 500000,
    DELEGATE: 75000000,
    CLAIM: 6000000
};
exports.GAS_PRICE = 1000000000;
exports.MIN_GAS_LIMIT = 50000;
exports.GAS_PER_DATA_BYTE = 1500;
exports.GAS_PRICE_MODIFIER = 0.01;
exports.CHAIN_ID = "1";
exports.MIN_DELEGATION_AMOUNT = new bignumber_js_1["default"](1000000000000000000);
exports.DECIMALS_LIMIT = 18;
exports.ELROND_EXPLORER_URL = "https://explorer.elrond.com";
exports.ELROND_STAKING_POOL = "erd1qqqqqqqqqqqqqqqpqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqplllst77y4l";
exports.ELROND_LEDGER_VALIDATOR_ADDRESS = "erd1qqqqqqqqqqqqqqqpqqqqqqqqqqqqqqqqqqqqqqqqqqqqppllllls9ftvxy";
//# sourceMappingURL=constants.js.map